export const CATEGORY_GLASS = "GLASS";
export const CATEGORY_LAMPS = "LAMPS";
export const CATEGORY_MOUTH_VASES = "MOUTH-VASES";
export const CATEGORY_PLATES = "PLATES";
export const CATEGORY_SALE = "SALE";
export const CATEGORY_ACCESSORIES = "ACCESSORIES";
export const CATEGORY_TABLES = "TABLES";
export const CATEGORY_BLACK_FRIDAY = "BLACK-FRIDAY";
